import { HOME_STATUSES } from '@zillow/home-details-variant';

var HOME_STATUS_LABELS = {
  FOR_SALE: 'For Sale',
  FOR_SALE_BY_OWNER: 'For Sale By Owner',
  OFF_MARKET: 'Off Market',
  SOLD: 'Sold',
  PENDING: 'Pending',
  ACCEPTING_BACKUPS: 'Accepting Backups',
  CONTINGENT: 'Contingent',
  UNDER_CONTRACT: 'Under Contract',
  LOT_LAND: 'Lot/Land',
  FORECLOSURE: 'Foreclosure',
  NEW_CONSTRUCTION: 'New Construction',
  AUCTION: 'Auction',
  COMING_SOON: 'Coming Soon',
  FOR_RENT: 'For Rent',
  FORECLOSED: 'Foreclosed',
  MMM: 'Make Me Move',
  PRE_FORECLOSURE: 'Pre-Foreclosure'
}; // enums from GraphQL: https://bitbucket.zgtools.net/projects/SERVICES/repos/graphql-data-provider/browse/src/pogo/homeType.js#7

var RENTALS_HOME_TYPE_DISPLAY = {
  HOME_TYPE_UNKNOWN: 'Home',
  SINGLE_FAMILY: 'House',
  MULTI_FAMILY: 'Apartment',
  APARTMENT: 'Apartment',
  TOWNHOUSE: 'Townhouse',
  LOT: 'Lot',
  MANUFACTURED: 'Home',
  CONDO: 'Condo'
};
var CONTINGENT_STATUS_TOOLTIPS = {
  PENDING: 'A pending listing means a seller has accepted an offer from a buyer. In some cases, the seller will accept backup offers.',
  ACCEPTING_BACKUPS: 'The seller has accepted an initial offer, but is still showing the home and taking backup offers from other interested buyers.',
  CONTINGENT: 'The seller has accepted an initial offer, but certain conditions must be met and, in some cases, the seller is taking backup offers.',
  UNDER_CONTRACT: 'The seller has accepted an offer, but the sale is not yet complete.'
};
var ICON_FOR_SALE = 'for-sale';
var ICON_PRE_MARKET = 'pre-market';
var ICON_OFF_MARKET = 'off-market';
var ICON_RECENTLY_SOLD = 'recently-sold';
var ICON_FOR_RENT = 'for-rent'; // These tokens correspond to the Constellation color tokens for
// home types: http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#/%40zillow%2Fconstellation/Tokens?id=section-colors

var CONSTELLATION_TOKEN_FOR_SALE = 'forSale';
var CONSTELLATION_TOKEN_OFF_MARKET = 'offMarket';
var CONSTELLATION_TOKEN_RECENTLY_SOLD = 'recentlySold';
var CONSTELLATION_TOKEN_FOR_RENT = 'forRent';
var HOME_STATUS_DESCRIPTION = {
  FOR_SALE: {
    display: HOME_STATUS_LABELS.FOR_SALE,
    icon: ICON_FOR_SALE,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  FOR_SALE_BY_OWNER: {
    display: HOME_STATUS_LABELS.FOR_SALE_BY_OWNER,
    icon: ICON_FOR_SALE,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  OTHER: {
    display: HOME_STATUS_LABELS.OFF_MARKET,
    icon: ICON_OFF_MARKET,
    constellationToken: CONSTELLATION_TOKEN_OFF_MARKET
  },
  SOLD: {
    display: HOME_STATUS_LABELS.SOLD,
    icon: ICON_RECENTLY_SOLD,
    constellationToken: CONSTELLATION_TOKEN_RECENTLY_SOLD
  },
  PENDING: {
    display: HOME_STATUS_LABELS.PENDING,
    verboseDisplay: 'This home has a pending offer.',
    icon: ICON_FOR_SALE,
    tooltip: CONTINGENT_STATUS_TOOLTIPS.PENDING,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  ACCEPTING_BACKUPS: {
    display: HOME_STATUS_LABELS.ACCEPTING_BACKUPS,
    verboseDisplay: 'This home is accepting backups.',
    icon: ICON_FOR_SALE,
    tooltip: CONTINGENT_STATUS_TOOLTIPS.ACCEPTING_BACKUPS,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  CONTINGENT: {
    display: HOME_STATUS_LABELS.CONTINGENT,
    verboseDisplay: 'This home is contingent.',
    icon: ICON_FOR_SALE,
    tooltip: CONTINGENT_STATUS_TOOLTIPS.CONTINGENT,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  UNDER_CONTRACT: {
    display: HOME_STATUS_LABELS.UNDER_CONTRACT,
    verboseDisplay: 'This home is under contract.',
    icon: ICON_FOR_SALE,
    tooltip: CONTINGENT_STATUS_TOOLTIPS.UNDER_CONTRACT,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  LOT: {
    display: HOME_STATUS_LABELS.LOT_LAND,
    icon: ICON_FOR_SALE,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  FORECLOSURE: {
    display: HOME_STATUS_LABELS.FORECLOSURE,
    icon: ICON_FOR_SALE,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  NEW_CONSTRUCTION: {
    display: HOME_STATUS_LABELS.NEW_CONSTRUCTION,
    icon: ICON_FOR_SALE,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  AUCTION: {
    display: HOME_STATUS_LABELS.AUCTION,
    icon: ICON_FOR_SALE,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  COMING_SOON: {
    display: HOME_STATUS_LABELS.COMING_SOON,
    icon: ICON_FOR_SALE,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  FOR_RENT: {
    display: HOME_STATUS_LABELS.FOR_RENT,
    icon: ICON_FOR_RENT,
    constellationToken: CONSTELLATION_TOKEN_FOR_RENT
  },
  FORECLOSED: {
    display: HOME_STATUS_LABELS.FORECLOSED,
    icon: ICON_PRE_MARKET,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  MMM: {
    display: HOME_STATUS_LABELS.MMM,
    icon: ICON_PRE_MARKET,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  },
  PRE_FORECLOSURE: {
    display: HOME_STATUS_LABELS.PRE_FORECLOSURE,
    icon: ICON_PRE_MARKET,
    constellationToken: CONSTELLATION_TOKEN_FOR_SALE
  }
};
var DEFAULT_HOME_STATUS = {
  display: '--',
  icon: ICON_OFF_MARKET,
  constellationToken: CONSTELLATION_TOKEN_OFF_MARKET
};
var CONTINGENT_LISTING_SUB_TYPES = ['ACCEPTING_BACKUPS', 'CONTINGENT', 'UNDER_CONTRACT'];

function getHomeStatusDisplayData(homeStatus, homeType, isSaved, listingSubType, contingentListingType, abTests, enableRoomForRent, displayAuctionStatusAsSold) {
  if (isSaved === void 0) {
    isSaved = false;
  }

  if (listingSubType === void 0) {
    listingSubType = {};
  }

  if (enableRoomForRent === void 0) {
    enableRoomForRent = false;
  }

  if (displayAuctionStatusAsSold === void 0) {
    displayAuctionStatusAsSold = false;
  }

  var statusDescriptionCriterion = null;
  var FOR_SALE = HOME_STATUSES.FOR_SALE;
  var FORECLOSED = HOME_STATUSES.FORECLOSED;
  var MMM = HOME_STATUSES.MMM;
  var OTHER = HOME_STATUSES.OTHER;
  var PENDING = HOME_STATUSES.PENDING;
  var PRE_FORECLOSURE = HOME_STATUSES.PRE_FORECLOSURE;
  var FOR_RENT = HOME_STATUSES.FOR_RENT;
  var SOLD = HOME_STATUSES.SOLD;
  var RECENTLY_SOLD = HOME_STATUSES.RECENTLY_SOLD; // homeStatus = PENDING and listingSubType.is_pending are one and the same

  if (homeStatus === PENDING) {
    if (CONTINGENT_LISTING_SUB_TYPES.includes(contingentListingType)) {
      statusDescriptionCriterion = contingentListingType;
    } else {
      statusDescriptionCriterion = homeStatus;
    }
  } else if (homeStatus === FOR_RENT) {
    statusDescriptionCriterion = homeStatus;
  } else if (homeStatus === FOR_SALE && CONTINGENT_LISTING_SUB_TYPES.includes(contingentListingType)) {
    // HDP-14618: contingent v2 extends 'Accepting backup offers' to FOR_SALE homeStatuses.
    statusDescriptionCriterion = contingentListingType;
  } else if (homeStatus === FOR_SALE && listingSubType.is_newHome) {
    statusDescriptionCriterion = 'NEW_CONSTRUCTION';
  } else if (displayAuctionStatusAsSold) {
    // MLS rule: NFS hdps displaying Auction status should instead display Sold
    statusDescriptionCriterion = 'SOLD';
  } else if (listingSubType.is_forAuction) {
    statusDescriptionCriterion = 'AUCTION';
  } else if (homeStatus === FOR_SALE && (listingSubType.is_bankOwned || listingSubType.is_foreclosure)) {
    statusDescriptionCriterion = 'FORECLOSURE';
  } else if (homeStatus === FOR_SALE && listingSubType.is_FSBO) {
    statusDescriptionCriterion = 'FOR_SALE_BY_OWNER';
  } else if (listingSubType.is_comingSoon) {
    statusDescriptionCriterion = 'COMING_SOON';
  } else if (homeStatus === FOR_SALE && homeType === 'LOT') {
    statusDescriptionCriterion = 'LOT';
  } else if (homeStatus === FOR_SALE || homeStatus === MMM || homeStatus === FORECLOSED || homeStatus === PRE_FORECLOSURE) {
    statusDescriptionCriterion = homeStatus;
  } else if (homeStatus === SOLD || homeStatus === RECENTLY_SOLD) {
    // Show "SOLD" for both Sold and Recently Sold homes
    statusDescriptionCriterion = 'SOLD';
  } else if (homeStatus === OTHER) {
    statusDescriptionCriterion = 'OTHER';
  }

  var displayData = HOME_STATUS_DESCRIPTION[statusDescriptionCriterion]; // log any unsupported Property Satus type and assign default Property Status display data

  if (!displayData) {
    displayData = DEFAULT_HOME_STATUS;
    console.trace('Unsupported homeStatus display data, got %j', homeStatus);
  } // show red icons for potential listings when SXP_HDP_BLUE_TO_RED set to ON


  if (abTests && abTests.SXP_HDP_BLUE_TO_RED === 'ON' && (homeStatus === MMM || homeStatus === FORECLOSED || homeStatus === PRE_FORECLOSURE)) {
    displayData.icon = ICON_FOR_SALE;
  }

  var icon = isSaved ? "zsg-icon-heart-filled " + displayData.icon : "zsg-icon-" + displayData.icon;
  var verboseDisplay = displayData.verboseDisplay ? displayData.verboseDisplay : null;
  var tooltip = displayData.tooltip ? displayData.tooltip : null;
  var displayOverride;

  if (homeStatus === FOR_RENT) {
    var _listingSubType;

    if ((_listingSubType = listingSubType) !== null && _listingSubType !== void 0 && _listingSubType.is_roomForRent && enableRoomForRent) {
      displayOverride = 'Room for rent';
    } else if (homeType) {
      displayOverride = RENTALS_HOME_TYPE_DISPLAY[homeType] + " for rent";
    } else {
      displayOverride = 'For rent';
    }
  } // returning new object with destructure to prevent returning mutable object


  return Object.assign({}, displayData, {
    icon: icon,
    tooltip: tooltip,
    verboseDisplay: verboseDisplay,
    displayOverride: displayOverride
  });
}

export { HOME_STATUS_LABELS, getHomeStatusDisplayData };
